export const fetchLocalUserData = ({storeKey = 'localUserData'}) => {
    try {
        const raw = localStorage.getItem(storeKey);
        if (!raw) return {};

        try {
            return JSON.parse(raw);
        } catch {
            return {};
        }
    } catch (error) {
        throw new Error('Local storage permission is needed');
    }
};

export const storeLocalUserData = ({userData = {}, storeKey = 'localUserData', clean = false}) => {
    try {
        const data = clean ? {...userData} : {...fetchLocalUserData({storeKey}), ...userData};
        localStorage.setItem(storeKey, JSON.stringify(data));
    } catch (error) {
        throw new Error('Local storage permission is needed');
    }
};

export const deleteLocalUserData = ({storeKey = 'localUserData'}) => {
    try {
        localStorage.removeItem(storeKey);
    } catch (error) {
        throw new Error('Local storage permission is needed');
    }
};
